import { FC, useEffect, useState } from "react";
import { Box } from "@mui/material";
import { useSnackbar } from "notistack";
import { useIntl } from "react-intl";
import { Navigate, useParams } from "react-router";

import type { IPage } from "@framework/types";
import { PageHeader, ProgressOverlay } from "@dzambalaorg/mui-page-layout";
import { RichTextDisplay } from "@dzambalaorg/mui-rte";
import { ApiError } from "@dzambalaorg/provider-api-firebase";
import { useApiCall } from "@dzambalaorg/react-hooks";

import { emptyPage } from "../../../components/common/interfaces";
import { Root } from "../../../components/common/styled";
import { StyledContentWrapper } from "./styled";

export const Page: FC = () => {
  const { slug = "" } = useParams<{ slug: string }>();
  const { enqueueSnackbar } = useSnackbar();
  const { formatMessage } = useIntl();

  const [notFound, setNotFound] = useState<boolean>(false);
  const [page, setPage] = useState<IPage>(emptyPage);

  const { fn: fetchPage, isLoading } = useApiCall(
    (api, slug: string) =>
      api
        .fetchJson({
          url: `/pages/${slug}`,
        })
        .then((json: IPage) => {
          setPage(json);
        })
        .catch((e: ApiError) => {
          if (e.status) {
            setNotFound(true);
          } else {
            console.error(e);
            enqueueSnackbar(formatMessage({ id: "snackbar.error" }), { variant: "error" });
          }
        }),
    { success: false, error: false },
  );

  useEffect(() => {
    void fetchPage(void 0, slug);
  }, [slug]);

  if (notFound) {
    return <Navigate to="/message/page-not-found" />;
  }

  return (
    <Root>
      <ProgressOverlay isLoading={isLoading}>
        <Box>
          <PageHeader message="pages.page.title" data={page} />
          <StyledContentWrapper>
            <RichTextDisplay data={page.description} />
          </StyledContentWrapper>
        </Box>
      </ProgressOverlay>
    </Root>
  );
};
